// extracted by mini-css-extract-plugin
export default {"tooltip":"IP-z","arrow":"JP-z"};